import Vue from 'vue'
import Router from 'vue-router'
import AppLogin from './views/AppLogin.vue'
import HomeNew from './views/HomeNew.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  mounted () {
    console.log('Router loaded')
  },
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeNew
    },
    {
      path: '/login',
      name: 'login',
      component: HomeNew
    },
    {
      path: '/app-login',
      alias: '/app/login',
      name: 'app-login',
      component: AppLogin
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "about" */ './views/Register.vue')
    },
    {
      path: '/register-full',
      name: 'register-full',
      component: () => import(/* webpackChunkName: "about" */ './views/RegisterFull.vue')
    },
    {
      path: '/app-register',
      name: 'app-register',
      component: () => import(/* webpackChunkName: "about" */ './views/Register.vue')
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: () => import(/* webpackChunkName: "about" */ './views/Confirm.vue')
    },
    {
      path: '/login-set-password',
      name: 'login-set-password',
      component: () => import(/* webpackChunkName: "about" */ './views/SetNewPassword.vue')
    },
    {
      path: '/send-confirm-code',
      name: 'send-confirm-code',
      component: () => import(/* webpackChunkName: "about" */ './views/SendConfirmCode.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import(/* webpackChunkName: "about" */ './views/ForgotPassword.vue')
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import(/* webpackChunkName: "about" */ './views/ResetPassword.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "about" */ './views/Profile.vue')
    },
    {
      path: '/auth/callback',
      name: 'authcallback',
      component: () => import(/* webpackChunkName: "about" */ './views/AuthCallback.vue')
    },
    {
      path: '/auth/facebook',
      name: 'authfacebook',
      component: () => import(/* webpackChunkName: "about" */ './views/AuthCallback.vue')
    },
    {
      path: '/auth/logout',
      name: 'authlogout',
      component: () => import(/* webpackChunkName: "about" */ './views/AuthLogout.vue')
    },
    {
      path: '/complete-registration',
      name: 'completeRegistration',
      component: () => import(/* webpackChunkName: "about" */ './views/CompleteRegistration.vue')
    },
    {
      path: '/token-redirect',
      name: 'tokenRedirect',
      component: () => import(/* webpackChunkName: "about" */ './views/TokenRedirect.vue')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
